import { Testimonial } from '../types';

export const TESTIMONIALS_DATA: Testimonial[] = [
  {
    id: 'test-1',
    name: 'Rajesh Kumar',
    role: 'Product Lead, Kolkata',
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=300&q=80',
    rating: 5,
    quote: 'I found an amazing companion for my sister’s wedding in Kolkata. The experience was fantastic, graceful, and very professional.',
  },
  {
    id: 'test-2',
    name: 'Priya Singh',
    role: 'Financial Analyst, Mumbai',
    avatar: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&w=300&q=80',
    rating: 5,
    quote: 'Great platform! I met someone wonderful for a weekend trip. Very safe, respectful and trustworthy service with secure Escrow OTP.',
  },
  {
    id: 'test-3',
    name: 'Amit Verma',
    role: 'Software Engineer, Bangalore',
    avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=300&q=80',
    rating: 5,
    quote: 'Perfect for someone like me who’s new in Bangalore. Made a lot of good memories exploring cafes and heritage spots.',
  },
  {
    id: 'test-4',
    name: 'Sneha Roy',
    role: 'Marketing Specialist, Delhi',
    avatar: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?auto=format&fit=crop&w=300&q=80',
    rating: 5,
    quote: 'The verification system gave me complete peace of mind. Rohan was super polite, punctual, and an incredible conversationalist for my company dinner.',
  },
  {
    id: 'test-5',
    name: 'Vikram Sengupta',
    role: 'Architect, Pune',
    avatar: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?auto=format&fit=crop&w=300&q=80',
    quote: 'Booking was super smooth and transparent with no hidden charges. Highly recommend PairUpToday to anyone needing quality companionship.',
    rating: 5,
  }
];

